const $ = require('jquery');
const intro = require('../vendor/intro').introJs();
const menu = require('./menu');
const loginPopups = require('./loginPopups');

module.exports = {
  init() {
    if (typeof op_tour_params === 'undefined') {
      return false;
    }

    intro.setOptions({
      showStepNumbers: false,
      nextLabel: op_tour_params.texts.next,
      doneLabel: op_tour_params.texts.done,
      skipLabel: op_tour_params.texts.done,
      tooltipClass: 'tourStep-tooltip',
      steps: op_tour_params.steps,
      exitOnOverlayClick: false,
    });

    $(document).on('click', '.introjs-overlay', (e) => {
      e.preventDefault();
      intro.nextStep();
    });
    $(document).on('click', '.tourStep-tooltip--last .introjs-nextbutton.introjs-disabled', (e) => {
      intro.exit();
    });

    let menu_disabled = false;
    let show_arrow = false;

    intro.onbeforechange((el) => {
      if ($(el).hasClass('tour-settings')) {
        $('#header-drop').removeClass('is-hidden');
        menu.disableDropdown();
        menu_disabled = true;
      } else if (menu_disabled == true) {
        menu.enableDropdown();
        menu_disabled = false;
      }
      if ($(el).hasClass('sliderArrow')) {
        $('.sliderArrow').addClass('sliderArrow--visible');
        show_arrow = true;
      } else if (show_arrow == true) {
        $('.sliderArrow').removeClass('sliderArrow--visible');
      }
    });

    intro.onafterchange((el) => {
      if ($(el).hasClass('tour-settings')) {
        // lai normāli rādītos dropdown
        $('#header-drop').removeClass('introjs-fixParent');
      }
    });

    $('.menu-notification').addClass('is-hidden');
    intro.start();

    intro.onexit((el) => {
      $('.menu-notification').removeClass('is-hidden');
      // loginPopups.init();
    });
    intro.oncomplete((el) => {
      $('.menu-notification').removeClass('is-hidden');
      // loginPopups.init();
    });

    // TODO kāpēc netiek uzstādīts pareiza bottom vērtība pirmajā reizē
    const tooltip = $('.introjs-tooltip');
    let tooltip_offset_bottom = tooltip.css('bottom').replace(/[^-\d\.]/g, '');
    tooltip_offset_bottom -= 15;
    tooltip.css({ bottom: `${tooltip_offset_bottom}px` });

    return true;
  },
};
